// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"14223832","455":"c05e206e","488":"68521f19","977":"608e27f2"}[chunkId] + ".chunk.js";
};